import { useCallback, useEffect, useState } from "react";
import { ordersAnalyticsApi } from "@/features/orders-analytics/api/orders-analytics.api";
import { OrdersAnalyticsFilters } from "@/features/orders-analytics/types/orders-analytics.types";

export function useAvailableClients(filters: OrdersAnalyticsFilters) {
    const [availableClients, setAvailableClients] = useState<string[]>([]);
    const [loading, setLoading] = useState(false);
    const [reloadKey, setReloadKey] = useState(0);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        ordersAnalyticsApi
            .fetchOrdersFilterOptions(filters)
            .then((options) => {
                if (!cancelled) {
                    setAvailableClients(options.clients);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setAvailableClients([]);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [filters, reloadKey]);

    const refresh = useCallback(() => {
        setReloadKey((key) => key + 1);
    }, []);

    return { availableClients, loading, refresh };
}
